import React from 'react'

import ListItem from './ListItem'
import Text, { SmallText } from '../presentation/Text'

const LabelListItem = ({
  label,
  description,
  title,
  color,
  onClick,
  disabled,
  reasonForDisablePresenter,
  option,
  ...props
}) => {
  const handleClick = () => {
    disabled && reasonForDisablePresenter && reasonForDisablePresenter(option)
    !disabled && onClick()
  }

  return (
    <ListItem onClick={handleClick} {...props}>
      <SmallText size="xxsmall" hideIfNull color={color}>
        {title}
      </SmallText>
      <Text color={color} {...props}>
        {label}
      </Text>
      <Text size="xsmall" hideIfNull color={color}>
        {description}
      </Text>
    </ListItem>
  )
}

export default LabelListItem
